import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { AuthService } from '../../../auth/service/auth.service';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class GetOptionsService {

  apiUrl: string = environment.apiUrl;
  testApi = 'https://test.api.tridimo.de/api/';
  devApi = 'https://dev.api.tridimo.de/api/';
  storedData: any

  constructor(private http: HttpClient, private authService: AuthService) { }

  async getStoredData() {
    this.storedData = localStorage.getItem("authUser"); 
  }

  checkToken(token: any) {
    try {
      const expirationTime = token * 1000;
      const currentTime = Date.now();
      if (currentTime > expirationTime) {
        console.log('Token ist älter als 60 Minuten');
        this.logout()
      } else {
        console.log('Token ist noch gültig');
      }
    } catch (e) {
      console.error('Fehler beim Dekodieren des Tokens:', e);
      this.logout()
    }
  }


  logout() {
    //localStorage.clear();
    sessionStorage.clear();
    this.authService.logout();
  }


  setFetchOptions(): { headers?: HttpHeaders; withCredentials?: boolean } {
    let options: { headers?: HttpHeaders; withCredentials?: boolean } = {};

    if (this.apiUrl === this.devApi) {
      let token = '';
      this.getStoredData();
      if (this.storedData) {
        try {
          const parsedData = JSON.parse(this.storedData);
          token = parsedData.token;
          this.checkToken(parsedData.exp);
        } catch {
          this.logout();
        }
      } else {
        this.logout();
      }

      options.headers = new HttpHeaders({
        Authorization: `${token}`,
        'Content-Type': 'application/json'
      });
    } else {
      options.withCredentials = true;
    }

    return options;
  }



  async fetchOptions() {
    const options = this.setFetchOptions();
    const response = await this.http.get(
      `${this.apiUrl}options`,
      options
    ).toPromise();
    //console.log('OPTIONS--> ',response)
    return response
  }

}
